@if (settingsEditPackageService.formGroup) {
  <div [formGroup]="settingsEditPackageService.formGroup" class="custom-package-container">
    <div class="custom-package-params">
      @if (validateBoxRulesDataError || (settingsEditPackageService.showFormErrors && getBannerErrors().length)) {
        <div class="banner-wrapper">
          <pdq-banner variant="danger" bannerTitle="Error banner">
            @for (error of getBannerErrors(); track error) {
              <ul>
                <li>{{ error }}</li>
              </ul>
            }
          </pdq-banner>
        </div>
      }
      <div class="input-wrapper">
        <pdq-input
          formControlName="name"
          type="text"
          label="Package name"
          [withIcon]="false"
          [autofocus]="false"
          placeholder='Give this package a name (e.g. "Small box")'
          variant="form"
          background="default"
          [border]="true"
          [autocompleteMode]="false"
          showBrowserAutocomplete="off">
        </pdq-input>
        @if (settingsEditPackageService.showFormErrors && !settingsEditPackageService.formGroup.get('name').valid) {
          <mat-error class="mat-error-text"> *Package name is required </mat-error>
        }
      </div>
      <div class="binding input-wrapper">
        <div class="binding__title">
          <p>Shortcut key (optional)</p>
          <pdq-icon
            icon="attention"
            matTooltip="Set a keyboard shortcut for this package"
            matTooltipClass="pdq-mat-tooltip"
            matTooltipPosition="above"
            size="20"></pdq-icon>
        </div>
        <div class="binding__content">
          <key-bind-dropdown
            [formControl]="settingsEditPackageService.formGroup.get('keybind')"
            [unavailableKeyBinds]="unavailableKeyBinds"></key-bind-dropdown>
        </div>
      </div>
      <div class="input-wrapper">
        <div class="input-header">Package type:</div>
        <pdq-radio-group formControlName="type">
          @for (ct of customTypes; track ct.value) {
            <pdq-radio-button
              [value]="ct.value"
              [checked]="settingsEditPackageService?.formGroup?.get('type')?.value === ct.value"
              [text]="ct.text">
            </pdq-radio-button>
          }
        </pdq-radio-group>
      </div>
      <div class="wrappers-container">
        <div class="columns-wrapper">
          <!-- Column 1: Dimensions -->
          <div class="column">
            <div class="inputs-row" style="margin: 20px 0px 20px 0px">Dimensions</div>
            <div class="inputs-row">
              <pdq-input-arrows
                formControlName="length"
                label="Length"
                variant="form"
                min="0"
                precision="3"
                background="default"
                [border]="true"></pdq-input-arrows>
              <pdq-input-arrows
                formControlName="width"
                label="Width"
                precision="3"
                variant="form"
                background="default"
                min="0"
                [border]="true"></pdq-input-arrows>
              <pdq-input-arrows
                formControlName="height"
                label="Height"
                precision="3"
                variant="form"
                min="0"
                background="default"
                [border]="true"></pdq-input-arrows>
              <!-- Distance Dropdown -->
              <pdq-dropdown
                class="distance-unit"
                [options]="distanceList"
                (onChange)="
                  settingsEditPackageService.formGroup.controls.distanceUnit.setValue($event.value);
                  settingsEditPackageService.formGroup.controls.distanceUnit.markAsDirty()
                "
                [defaultOption]="{
                  label: settingsEditPackageService.formGroup.controls.distanceUnit.value,
                  value: settingsEditPackageService.formGroup.controls.distanceUnit.value,
                }">
              </pdq-dropdown>
            </div>
            @if (
              settingsEditPackageService.showFormErrors &&
              (!settingsEditPackageService.formGroup.get('length').valid ||
                !settingsEditPackageService.formGroup.get('width').valid ||
                !settingsEditPackageService.formGroup.get('height').valid)
            ) {
              <mat-error class="mat-error-text">
                {{ getUnitsError() }}
              </mat-error>
            }
          </div>
          @if (supportsPaccurate) {
            <div class="column">
              <div class="vertical-separator"></div>
            </div>
          }
          <!-- Column 2: Inner Dimensions -->
          @if (supportsPaccurate) {
            <div class="column">
              <div class="inputs-row" style="margin: 20px 0px 20px 0px">
                <div class="caption-wrapper">
                  <pdq-icon class="pdq-iq-icon" icon="pdqiq"></pdq-icon>
                  <div class="caption">Inner Dimensions (Optional)</div>
                  <pdq-icon
                    icon="attention"
                    matTooltip="Relevant for PDQ IQ"
                    matTooltipClass="pdq-mat-tooltip"
                    matTooltipPosition="above"
                    size="20"></pdq-icon>
                </div>
              </div>
              <div class="inputs-row">
                <div formGroupName="innerDimensions" style="display: flex; gap: 16px">
                  <pdq-input-arrows
                    formControlName="innerLength"
                    label="Inner length"
                    variant="form"
                    min="0"
                    precision="3"
                    background="default"
                    [border]="true"></pdq-input-arrows>
                  <pdq-input-arrows
                    formControlName="innerWidth"
                    label="Inner width"
                    precision="3"
                    variant="form"
                    background="default"
                    min="0"
                    [border]="true"></pdq-input-arrows>
                  <pdq-input-arrows
                    formControlName="innerHeight"
                    label="Inner height"
                    precision="3"
                    variant="form"
                    min="0"
                    background="default"
                    [border]="true"></pdq-input-arrows>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="number-inputs-wrapper">
          <div class="weight-wrappers-container">
            <!-- Weight Wrapper -->
            <div class="weight-wrapper">
              <div class="caption-wrapper">
                <div class="caption">Weight when empty (optional)</div>
                <pdq-icon
                  icon="attention"
                  matTooltip="Added to products in package weight calculation"
                  matTooltipClass="pdq-mat-tooltip"
                  matTooltipPosition="above"
                  size="20"></pdq-icon>
              </div>
              <div class="input-arrows">
                <pdq-input-arrows
                  precision="3"
                  formControlName="additionalWeight"
                  variant="form"
                  min="0"
                  background="default"
                  [border]="true"></pdq-input-arrows>
                <pdq-dropdown
                  [options]="settingsEditPackageService.weightList"
                  (onChange)="
                    settingsEditPackageService.formGroup.controls.additionalWeightUnit.setValue($event.value);
                    settingsEditPackageService.formGroup.controls.additionalWeightUnit.markAsDirty()
                  "
                  [defaultOption]="{
                    label: settingsEditPackageService.formGroup.controls.additionalWeightUnit.value,
                    value: settingsEditPackageService.formGroup.controls.additionalWeightUnit.value,
                  }">
                </pdq-dropdown>
              </div>
            </div>
            <!-- Max Package Weight Wrapper -->
            @if (supportsPaccurate) {
              <div class="max-package-weight-wrapper">
                <div class="caption-wrapper">
                  <pdq-icon class="pdq-iq-icon" icon="pdqiq"></pdq-icon>
                  <div class="caption">Maximum package weight</div>
                  <pdq-icon
                    icon="attention"
                    matTooltip="Required only for PDQ IQ"
                    matTooltipClass="pdq-mat-tooltip"
                    matTooltipPosition="above"
                    size="20"></pdq-icon>
                </div>
                <div class="max-package-weight-input">
                  <pdq-input-arrows
                    precision="3"
                    formControlName="maxWeightCapacity"
                    variant="form"
                    background="default"
                    [border]="true"
                    min="0">
                  </pdq-input-arrows>
                  <pdq-dropdown
                    [options]="settingsEditPackageService.weightList"
                    (onChange)="
                      settingsEditPackageService.formGroup.controls.maxWeightCapacityUnit.setValue($event.value)
                    "
                    [defaultOption]="{
                      label: settingsEditPackageService.formGroup.controls.maxWeightCapacityUnit.value,
                      value: settingsEditPackageService.formGroup.controls.maxWeightCapacityUnit.value,
                    }">
                  </pdq-dropdown>
                </div>
                <!-- Error Message -->
                @if (
                  settingsEditPackageService.showFormErrors &&
                  !settingsEditPackageService.formGroup.get('maxWeightCapacity').valid
                ) {
                  <mat-error class="mat-error-text">
                    {{ getMaxWeightCapacityError() }}
                  </mat-error>
                }
              </div>
            }
          </div>
          <div class="weight-section">
            <div class="weight-switch-wrapper">
              <pdq-slide-toggle
                formControlName="isUseMaximalWeight"
                [label]="'Max order weight'"
                [subtext]="'Set the heaviest order this package can handle'">
              </pdq-slide-toggle>
            </div>
            <div class="max-weight-wrapper">
              <div
                class="caption"
                [ngClass]="{ disabled: !settingsEditPackageService.formGroup.controls.isUseMaximalWeight.value }">
                Package’s fixed weight
              </div>
              <div class="max-weight-input">
                <pdq-input-arrows
                  precision="3"
                  [disabled]="!settingsEditPackageService.formGroup.controls.isUseMaximalWeight.value"
                  formControlName="maxWeight"
                  variant="form"
                  background="default"
                  [border]="true"
                  min="0">
                </pdq-input-arrows>
                <pdq-dropdown
                  [options]="settingsEditPackageService.weightList"
                  (onChange)="settingsEditPackageService.formGroup.controls.maxWeightUnit.setValue($event.value)"
                  [disabled]="!settingsEditPackageService.formGroup.controls.isUseMaximalWeight.value"
                  [defaultOption]="{
                    label: settingsEditPackageService.formGroup.controls.maxWeightUnit.value,
                    value: settingsEditPackageService.formGroup.controls.maxWeightUnit.value,
                  }">
                </pdq-dropdown>
              </div>
              @if (
                settingsEditPackageService.showFormErrors &&
                !settingsEditPackageService.formGroup.get('maxWeight').valid
              ) {
                <mat-error class="mat-error-text">
                  {{ getMaxWeightError() }}
                </mat-error>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (isFormInit) {
      <app-settings-package-condition [rules]="boxData?.rules"></app-settings-package-condition>
    }
    <footer [ngClass]="settingsEditPackageService.formGroup.dirty ? 'apear' : 'initial'">
      <span>You have unsaved settings</span>
      <pdq-button
        variant="secondary"
        [disabled]="isLoading"
        (click)="resetForm()"
        label="cancel"
        class="action-btn"></pdq-button>
      <pdq-button
        variant="primary"
        type="submit"
        label="save"
        class="action-btn"
        (click)="onSubmit()"
        [loading]="isLoading">
      </pdq-button>
    </footer>
  </div>
}
